module.exports = __webpack_public_path__ + "media/images/consumer/signup/payment/credit-card/jcb@2x-8bac76aeefe080b1faf96f2f43a7254d.png";